import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { ISupplier, SupplierTravelActivityBookings } from "../../../../Supplier"
import { useOutletContext } from "react-router"

export default function SupplierBookingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
		>
			<Helmet>
				<title>Travel Activity Bookings | Supplier</title>
			</Helmet>
			<SupplierTravelActivityBookings
				transportServiceProvider={transportServiceProvider}
			/>
		</ForbidUnlessAuthorized>
	)
}
